export default __webpack_public_path__ + "static/media/frenchpress_for_2.09d68b18.png";